import React, { useState, useEffect } from 'react';
import { Card } from 'antd';
import DashboardHome from './components/DashboardHome';
import DashboardTarget from './components/DashboardTarget';
// import DashboardVasBooked from './components/DashboardVasBooked';
import DashboardVasRetailed from './components/DashboardVasRetailed';
import DashboardExchange from './components/DashboardExchange';
import DashboardStock from './components/DashboardStock';
import PageContentHeader from '../../../components/common/PageContentHeader';
import { useSelector } from 'react-redux';

const AdminDashboard = () => {
  const roleType = useSelector((state) => state?.auth?.userData?.role);
  const isExchangeEvaluationTeam = roleType === "Exchange Evaluation Team" || roleType === "Procurement Manager";
  
  // Check if user is Head Office Manager (show only Home tab)
  const isHeadOfficeManager = roleType === 'Head Office Manager';
  
  // Check if user is in restricted roles (Back Office, Finance Manager - show only Stock tab)
  const isRestrictedRole = 
    roleType === 'Back Office Manager' || 
    roleType === 'Finance Manager';

  // For restricted roles, only show Stock tab
  const allTabs = [
    {
      key: 'home',
      label: 'Home',
    },
    isExchangeEvaluationTeam ? null : (
      {
        key: 'targets',
        label: 'Targets',
      }),
    // isExchangeEvaluationTeam ? null : (
    //   {
    //     key: 'vasBooked',
    //     label: 'VAS Report(Booked)',
    //   }
    // ),
    isExchangeEvaluationTeam ? null : (
      {
        key: 'vasReport',
        label: 'VAS Reports',
      }
    ),
    isExchangeEvaluationTeam ? null : (
    {
      key: 'exchange',
      label: 'Exchange',
    }
  ),
    isExchangeEvaluationTeam ? null : (
    {
      key: 'stock',
      label: 'Stock',
    }
  ),
  ];

  // Filter out null values and restrict tabs based on role
  const tabListNoTitle = isHeadOfficeManager
    ? allTabs.filter(tab => tab && tab.key === 'home')
    : isRestrictedRole 
      ? allTabs.filter(tab => tab && tab.key === 'stock')
      : allTabs.filter(tab => tab !== null && tab !== "");

  const contentListNoTitle = {
    home: <DashboardHome />,
    targets: < DashboardTarget />,
    // vasBooked: <DashboardVasBooked />,
    vasReport: <DashboardVasRetailed />,
    exchange: <DashboardExchange />,
    stock: <DashboardStock />,
  };
  
  const [activeTabKey, setActiveTabKey] = useState(
    isHeadOfficeManager ? 'home' : isRestrictedRole ? 'stock' : 'home'
  );

  useEffect(() => {
    if (isHeadOfficeManager && activeTabKey !== 'home') {
      setActiveTabKey('home');
    }
    if (isRestrictedRole && activeTabKey !== 'stock') {
      setActiveTabKey('stock');
    }
    if (isExchangeEvaluationTeam && activeTabKey === 'stock') {
      setActiveTabKey('home');
    }
  }, [isHeadOfficeManager, isRestrictedRole, isExchangeEvaluationTeam, activeTabKey]);

  const onTabChange = (key) => {
    // For Head Office Manager, only allow switching to 'home' tab
    if (isHeadOfficeManager && key !== 'home') {
      setActiveTabKey('home');
      return;
    }
    // For restricted roles (Back Office, Finance), only allow switching to 'stock' tab
    if (isRestrictedRole && key !== 'stock') {
      setActiveTabKey('stock');
      return;
    }
    // For Exchange Evaluation Team and Procurement Manager, prevent access to stock tab
    if (isExchangeEvaluationTeam && key === 'stock') {
      return;
    }
    setActiveTabKey(key);
  };
  return (
    <>
      <div className='user-data'>
        <PageContentHeader title="Dashboard" />
        <div className='card-tab'>
          <Card
            tabList={tabListNoTitle}
            activeTabKey={activeTabKey}
            tabBarExtraContent={<a href="#">More</a>}
            onTabChange={onTabChange}
            tabProps={{
              size: 'middle',
            }}
          >
            {contentListNoTitle[activeTabKey]}
          </Card>
        </div>
      </div>
    </>
  );
};

export default AdminDashboard;
